module.exports = __webpack_public_path__ + "img/admission-2.90f08a4b.jpg";